import axios from "axios";

// When REACT_APP_BACKEND_URL is empty the app calls the API at a relative /api
// path, so the same build works on localhost and on the live domain (nginx
// proxies /api/ to the backend). Set it only when the API is on another origin.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

export function apiErr(detail, fallback = "Something went wrong.") {
  const d = detail?.response?.data?.detail ?? detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return typeof d === "object" ? fallback : String(d);
}

export { BACKEND_URL };
export default api;
